import { Component, OnInit, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { CandidatosCsvDTO } from 'src/app/models/candidatosCsvDTO.model';
import { CanditadosService } from 'src/app/services/canditados.service';
import { CandidatoComponent } from '../../parametrizacoes/candidato/candidato.component';
import { Utils } from 'src/app/utils/utils';
import { LoadingBarService } from '@ngx-loading-bar/core';


@Component({
  selector: 'cadastro-massa-candidato',
  templateUrl: './candidato-csv-import.component.html',
  styleUrls: ['./candidato-csv-import.component.css']
})

export class CandidatoCsvComponent implements OnInit {
  idEleicao: any;
  token: any;
  candidatosArray: CandidatosCsvDTO[] = [];
  newCandidatosArray: CandidatosCsvDTO[] = [];
  candidatosCriticados: any = [];
  candidatosEnviados: any = [];
  candidatosDuplicados: any = [];
  btOff: boolean = false;
  ativaNavValidacao: boolean = false;
  ativaNavEnviar: boolean = false;
  ativaNavEnviados: boolean = false;
  ativaNavDuplicados: boolean = false;
  loader = this.loadingBar;

  

  @Input() listaCargos: any;

  constructor(
    private candidatoComponent: CandidatoComponent,
    public canditadosService: CanditadosService,
    protected messageService: MessageService,
    public utils: Utils,
    private loadingBar: LoadingBarService
  ) { }

  ngOnInit() {
    this.token = sessionStorage.getItem("token");
    this.idEleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao")).id;
  }

  validaTipoArquivo(file: any) {
    return file.name.endsWith(".csv");
  }

  zerarInputFile(element?) {
    if (element) {
      element.value = '';
    }
    this.newCandidatosArray = [];
    this.candidatosCriticados = [];
    this.candidatosDuplicados = [];
    this.candidatosEnviados = [];
  }

  getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any) {
    let csvArr = [];

    for (let i = 1; i < csvRecordsArray.length; i++) {
      let currentRecord = csvRecordsArray[i].split(';');
      if (currentRecord.length == headerLength) {
        let csv: CandidatosCsvDTO = new CandidatosCsvDTO();
        csv.nome = currentRecord[0].trim();
        csv.cpf = currentRecord[1].trim();
        csv.cargo = { "nome": currentRecord[2].trim() };
        csv.curriculum = currentRecord[3].trim();
        csv.eleicaoId = { "id": this.idEleicao };
        csv.votoJustificavel = (currentRecord[4].trim().toUpperCase() == "SIM") ? true : false;
        csv.parametroJustificativa = currentRecord[5].trim();
        csvArr.push(csv);
      }
    }
    return csvArr;
  }

  importarCsv(event) {
    this.zerarInputFile();

    let arquivos = event.srcElement.files;

    if (this.validaTipoArquivo(arquivos[0])) {
      let input = event.target;
      let fileReader = new FileReader();
      fileReader.readAsText(input.files[0]);

      fileReader.onload = () => {
        let csvData = fileReader.result;
        let csvRecordsArray = csvData.toString().split(/\r\n|\n/);
        let headersRow = this.utils.getHeaderArray(csvRecordsArray);
        this.candidatosArray = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length);
        this.candidatoCsvParaNovosCandidatoDTO(this.candidatosArray);
        this.validaNavTab();
      };
    } else {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: 'O arquivo selecionado não é um .csv válido!' });
      this.candidatosArray = [];
    }
  }

  private async insercaoEmMassa(candidatos: CandidatosCsvDTO[]) {
    const state = this.loader
    state.start();
    await this.canditadosService.insercaoEmMassaCandidatos(candidatos, this.token).then((resp: any) => {
      this.candidatosEnviados = resp.enviados;
      this.candidatosDuplicados = resp.duplicados;
      this.newCandidatosArray = [];
      this.validaNavTabAposSalvar();
      if (this.candidatosEnviados.length > 0) {
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Candidatos enviados com sucesso!' });
        state.complete();
        this.candidatoComponent.listarCandidatosExistentes();
      }
    }, error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: '', detail: error });
    });
  }

  importarList() {
    this.insercaoEmMassa(this.newCandidatosArray);
  }

  candidatoCsvParaNovosCandidatoDTO(candidatoCsv: CandidatosCsvDTO[]) {
    for(let candidato of candidatoCsv) {
      let novoCandidato: CandidatosCsvDTO = new CandidatosCsvDTO();
      const idCargo = this.getIdCargo(candidato.cargo.nome);
      novoCandidato.nome = candidato.nome;
      novoCandidato.cpf = candidato.cpf;
      novoCandidato.cargo = { "id": idCargo, "nome": candidato.cargo.nome };
      novoCandidato.curriculum = candidato.curriculum;
      novoCandidato.votoJustificavel = candidato.votoJustificavel;
      novoCandidato.parametroJustificativa = candidato.parametroJustificativa;

      if (!novoCandidato.nome || novoCandidato.nome == ""){
        this.candidatosCriticados.push({ novoCandidato, critica: "Validação 1" });
      } else if (!idCargo) {
        this.candidatosCriticados.push({ novoCandidato, critica: "Validação 2 ou 4" });
      } else if (!novoCandidato.curriculum || novoCandidato.curriculum == "") {
        this.candidatosCriticados.push({ novoCandidato, critica: "Validação 3" });
      } else if (!this.isValidCPF(novoCandidato.cpf)) {
        this.candidatosCriticados.push({ novoCandidato, critica: "Validação 5" });
      } else if(novoCandidato.votoJustificavel == null){
        this.candidatosCriticados.push({ novoCandidato, critica: "Validação 6" });
      } else if(novoCandidato.votoJustificavel && (!novoCandidato.parametroJustificativa || novoCandidato.parametroJustificativa == "")){
        this.candidatosCriticados.push({ novoCandidato, critica: "Validação 7" });
      }else {
        this.newCandidatosArray.push(novoCandidato);
      }
    }
  }

  validaNavTab() {
    if (this.candidatosCriticados.length > 0 && this.candidatosDuplicados.length == 0 && this.candidatosEnviados.length == 0) {
      this.ativaNavValidacao = true;
    } else {
      this.ativaNavValidacao = false;
    }

    if (this.candidatosCriticados.length == 0 && this.newCandidatosArray.length > 0) {
      this.ativaNavEnviar = true;
    } else {
      this.ativaNavEnviar = false;
    }
  }

  validaNavTabAposSalvar() {
    if (this.candidatosDuplicados.length > 0) {
      this.ativaNavDuplicados = true;
      this.ativaNavValidacao = false;
      this.ativaNavEnviar = false;
    } else {
      this.ativaNavDuplicados = false;
    }

    if (this.candidatosDuplicados.length == 0 && this.candidatosEnviados.length > 0) {
      this.ativaNavEnviados = true;
      this.ativaNavValidacao = false;
      this.ativaNavEnviar = false;
    } else {
      this.ativaNavEnviados = false;
    }
  }

  getIdCargo(cargo: string) {
    const cargoObj = this.listaCargos.find(element => element.nome == cargo)
    if (cargoObj){
      return cargoObj.id;
    }
    return null;
  }

  isValidCPF(cpf: any) {
    if (!cpf || cpf == '' ) {
      return true;
    }
    cpf = cpf.replace(/[^\d]+/g,'');
    if (cpf.length != 11 ||
      cpf == "00000000000" ||
      cpf == "11111111111" ||
      cpf == "22222222222" ||
      cpf == "33333333333" ||
      cpf == "44444444444" ||
      cpf == "55555555555" ||
      cpf == "66666666666" ||
      cpf == "77777777777" ||
      cpf == "88888888888" ||
      cpf == "99999999999") {
      return false;
    }
    let sum = 0;
    for (let i=0; i < 9; i ++) {
      sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let rest = (sum * 10) % 11;
    if (rest == 10 || rest == 11) {
      rest = 0;
    }
    if (rest != parseInt(cpf.charAt(9))) {
      return false;
    }

    sum = 0;
    for (let i = 0; i < 10; i ++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    rest =  (sum * 10) % 11;
    if (rest == 10 || rest == 11) {
      rest = 0;
    }
    if (rest != parseInt(cpf.charAt(10))) {
      return false;
    }
    return true;
  }
}